import { createSelector } from 'reselect';

const getpaymentsState = (state) => state.payments;

export const paymentsSelector = createSelector([getpaymentsState], (paymentsState) => {
  const {
    users,
  } = paymentsState;

  return {
    users,
  };
});
